var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMidRecBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 5,
    viewBox: "0 0 30 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.967 0.996094H1.78512C0.799228 0.996094 0 1.79532 0 2.78122C0 3.76712 0.799228 4.56634 1.78512 4.56634H27.967C28.9529 4.56634 29.7521 3.76712 29.7521 2.78122C29.7521 1.79532 28.9529 0.996094 27.967 0.996094Z",
    fill: "#DEE9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidRecBottom);
export default __webpack_public_path__ + "static/media/midRecBottom.3335cb98597e7903a0135c307d1e2a22.svg";
export { ForwardRef as ReactComponent };